import { ABaseModel } from '../abstracts/ABaseModel.js';
import { ListResult, PaginationResult } from './List.js';
import { IOffer, IOfferPaginationResult, IOfferLog, IOfferLogListResult, IOfferAction } from '../interfaces/Offer.js';
import { Art, ProductSku } from './Art.js';

/**
 * Offer
 */
class Offer extends ABaseModel implements IOffer {
  id: number;
  status: string;
  state: string;
  created: string;
  updated: string;
  acceptedDate: string;
  expiryDate: string;
  productSku: string;
  productPrice: number;
  userId: number;
  customerEmail: string;
  customerFirstName: string;
  customerLastName: string;
  customerPhone: string;
  offerCurrencyCode: string;
  offerAmount: number;
  offerCounter: number;
  offerAgreed: number;
  sellerCurrencyCode: string;
  sellerProductPrice: number;
  sellerAmount: number;
  sellerCounter: number;
  sellerAgreed: number;
  artId: number;
  canAccept: boolean;
  canCounter: boolean;
  canDecline: boolean;
  canExtend: boolean;
  canCancel: boolean;
  storeCode: string;
  art: Art;
  sku: ProductSku;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * OfferPaginationResult
 */
class OfferPaginationResult extends PaginationResult implements IOfferPaginationResult {
  declare items: Array<Offer>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * OfferLog
 */
class OfferLog extends ABaseModel implements IOfferLog {
  id: number;
  offerId: number;
  created: string;
  type: string;
  state: string;
  amount: number;
  comment: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * OfferLogListResult
 */
class OfferLogListResult extends ListResult implements IOfferLogListResult {
  declare items: Array<OfferLog>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * OfferAction
 */
class OfferAction extends ABaseModel implements IOfferAction {
  id: string;
  action: string;
  offerId: number;
  executed: string;
  status: string;

  /**
   * constructor
   */
  constructor() {
    super();
  }
}

export { Offer, OfferPaginationResult, OfferLog, OfferLogListResult, OfferAction };
